import { FormattedHTMLMessage } from '@99designs/common/i18n';
import ColorComponent from 'projects/components/Color';
import { Color } from 'projects/consts';
import React from 'react';

const SquareAuthModalDirect = {
    signupHeading: __('Welcome to 99designs!'),
    signupMessage: (
        <div className="auth-description">
            <ColorComponent color={Color.puntRoad}>
                <div className="paragraph paragraph--small">
                    <FormattedHTMLMessage
                        message={__(
                            "Let's create your 99designs account so you can start collaborating on your <strong>Square Online Store</strong> project."
                        )}
                    />
                </div>
            </ColorComponent>
        </div>
    ),
};

export default SquareAuthModalDirect;
